import { Box } from '@mui/material'
import { mapLoader } from 'components/domain/GoogleMaps'
import type React from 'react'
import { useEffect } from 'react'

const PaymentLocationMap: React.FC = () => {
    useEffect(() => {
        mapLoader.importLibrary('maps').then(({ Map, InfoWindow }) => {
            const map = new Map(document.getElementById('map') as HTMLElement, {
                center: { lat: 33.9140327, lng: -117.2653872 },
                zoom: 12,
                mapId: 'DEMO_MAP_ID',
                streetViewControl: false,
                mapTypeControl: false
            })
            const infoWindowContent = `
                <div>
                    <div style="display: flex; justify-content: space-between; width: 100%">
                        <div style="text-align: left; width: 75%">
                            <div><b>Moreno Valley Electrical Utility</b></div>
                            <div>14225 Corporate Way, Moreno Valley, CA 92553</div>
                            <div>Monday - Thursday 7:30AM - 5:30PM</div>
                            <div>Friday 8:00AM - 5:00PM</div>
                            <div>(844) 425-0855</div>
                            <a href="https://maps.app.goo.gl/DpW5LyRD34qMevhN7"
                            target="_blank"
                            rel="noreferrer"
                        >
                            View larger map
                        </a>
                        </div>
                        <div style="text-align: right; width: 25%">
                            <a style="color: #3a84df; display: block; height: 43px; text-decoration: none; width: 54.7344px" target="_blank" href="https://www.google.com/maps/dir//14225+Corporate+Way,+Moreno+Valley,+CA+92553,+USA/@33.9139329,-117.2654966,19z/data=!4m18!1m8!3m7!1s0x80dca6751a9c241d:0xdb5cc2ac72432efd!2s14225+Corporate+Way,+Moreno+Valley,+CA+92553,+USA!3b1!8m2!3d33.9140176!4d-117.265387!16s%2Fg%2F11c48gkw3h!4m8!1m0!1m5!1m1!1s0x80dca6751a9c241d:0xdb5cc2ac72432efd!2m2!1d-117.265387!2d33.9140176!3e3?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D" rel="noreferrer">
                            <div style="background: rgba(0, 0, 0, 0) url(https://maps.gstatic.com/mapfiles/embed/images/entity11.png) no-repeat; height: 22px; width: 22px; margin-right: auto; margin-left: auto"></div>    
                            Directions
                            </a>
                        </div>
                    </div>
                </div>
            `
            const infoWindow = new InfoWindow({
                content: infoWindowContent,
                disableAutoPan: true
            })
            mapLoader.importLibrary('marker').then(({ AdvancedMarkerElement }) => {
                const marker = new AdvancedMarkerElement({
                    map,
                    position: { lat: 33.9140327, lng: -117.2653872 },
                    title: 'Moreno Valley Electrical Utility'
                })
                infoWindow.open(map, marker)
                return marker
            }).catch((e) => { console.log(e) })
        }).catch((e) => { console.log(e) })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box id="map" flex={1} />
    )
}

export default PaymentLocationMap
